import { createJurisdictionHeaders } from '@/data';
import { URLS } from '@/data/config';
import { useMutation } from '@tanstack/react-query';

export const CASINO_ROUND_DETAILS_MUTATION_KEY = ['casino-round-details'];

export interface CasinoRoundDetailsResponse {
    data: string;
}

export const getCasinoRoundDetails = async (roundId: string): Promise<CasinoRoundDetailsResponse> => {
    const response = await fetch(`${URLS.CHAMELON_API_URL}/auth/casino/round-details/${roundId}`, {
        method: 'GET',
        headers: {
            ...createJurisdictionHeaders(),
            JURISDICTION: 'CASH-CASINO',
            'Content-Type': 'application/json',
        },
    });
    const data = await response.json();

    if (!response.ok) {
        throw data;
    }
    return data;
};

export function useCasinoRoundDetails() {
    return useMutation({
        mutationKey: CASINO_ROUND_DETAILS_MUTATION_KEY,
        mutationFn: getCasinoRoundDetails,
    });
}
